import styled from 'styled-components';
import Typography from '../../../Typography';
export const DateCellStyled = styled(Typography) `
  display: flex;
  justify-content: center;
`;
//# sourceMappingURL=styled.js.map